import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';

/**
 * Landing mobile-first y corta: cada bloque avanza hacia la compra sin repetir
 * argumentos. Todo lo que está debajo del primer viewport se carga en diferido
 * para que el Hero (LCP) llegue con el menor JS posible.
 *
 * Recorrido: hero → problema/solución → biblioteca de 200 → qué podés fabricar
 * → 4 tomos → dentro de una fórmula → 5 bonos → oferta → FAQ → cierre.
 */
const ProblemSolutionSection = lazy(() => import('./components/ProblemSolutionSection').then(m => ({
  default: m.ProblemSolutionSection
})));
const LibrarySection = lazy(() => import('./components/LibrarySection').then(m => ({
  default: m.LibrarySection
})));
const VarietySection = lazy(() => import('./components/VarietySection').then(m => ({
  default: m.VarietySection
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const FormulaSection = lazy(() => import('./components/FormulaSection').then(m => ({
  default: m.FormulaSection
})));
const BonosSection = lazy(() => import('./components/BonosSection').then(m => ({
  default: m.BonosSection
})));
const InsidePagesSection = lazy(() => import('./components/InsidePagesSection').then(m => ({
  default: m.InsidePagesSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const FinalCta = lazy(() => import('./components/FinalCta').then(m => ({
  default: m.FinalCta
})));
const LegalNotice = lazy(() => import('./components/LegalNotice').then(m => ({
  default: m.LegalNotice
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const StickyBuyBar = lazy(() => import('./components/StickyBuyBar').then(m => ({
  default: m.StickyBuyBar
})));
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
}
function Deferred({
  children,
  minHeight,
  background = 'bg-cream'
}: DeferredProps) {
  return <Suspense fallback={<div className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="86w76wno4g2y" />} data-id="element-0" data-mp="85bap1hsmn2g">
      {children}
    </Suspense>;
}
export function App() {
  return <main className="w-full bg-cream pb-16 text-charcoal sm:pb-0" data-id="element-2" data-mp="3bmjqzgwvhev2">
      <Hero data-id="element-3" data-mp="3bk6zod585s5c" />
      <Deferred minHeight="520px" background="bg-white" data-id="element-4" data-mp="3bkgse8hnmdeq">
        <ProblemSolutionSection data-id="element-5" data-mp="3qbze8mx73260" />
      </Deferred>
      <Deferred minHeight="420px" background="bg-charcoal" data-id="element-6" data-mp="3lkhge7qgxhp9">
        <LibrarySection data-id="element-7" data-mp="3liwm8j82g0rx" />
      </Deferred>
      <Deferred minHeight="520px" background="bg-sand" data-id="element-8" data-mp="2xun2rnybrp3y">
        <VarietySection data-id="element-9" data-mp="2xtbw9gdhw395" />
      </Deferred>
      <Deferred minHeight="420px" data-id="element-10" data-mp="2sw20zk3fcxde">
        <TomosSection data-id="element-11" data-mp="2suquvdmibdj4" />
      </Deferred>
      <Deferred minHeight="420px" background="bg-white" data-id="element-12" data-mp="2stpjf81kwp0v">
        <FormulaSection data-id="element-13" data-mp="18cq41f9j46qa" />
      </Deferred>
      <Deferred minHeight="520px" background="bg-sand" data-id="element-14" data-mp="18bya08vkyh24">
        <BonosSection data-id="element-15" data-mp="1d5j8e2135d1u" />
      </Deferred>
      <Deferred minHeight="680px" data-id="element-16" data-mp="1d6aw6qofy6hk">
        <InsidePagesSection data-id="element-17" data-mp="yg3lix4odrrf" />
      </Deferred>
      <Deferred minHeight="560px" background="bg-white" data-id="element-18" data-mp="yhepawy4ezij">
        <TestimonialsSection data-id="element-19" data-mp="13dwt9ulmmttt" />
      </Deferred>
      <Deferred minHeight="640px" data-id="element-20" data-mp="13clobrgg3g14">
        <OfferSection data-id="element-21" data-mp="1r4ir6t1x2xq3" />
      </Deferred>
      <Deferred minHeight="520px" data-id="element-22" data-mp="1r5k8vgdfuigs">
        <FaqSection data-id="element-23" data-mp="1r2g2qdgexcnh" />
      </Deferred>
      <Deferred minHeight="320px" background="bg-white" data-id="element-24" data-mp="1w3lwmelt75yl">
        <FinalCta data-id="element-25" data-mp="1w0zmc77jacco" />
      </Deferred>
      <Deferred minHeight="220px" data-id="element-26" data-mp="1i4ce38a4rzrg">
        <LegalNotice data-id="element-27" data-mp="1i31e7jjt3c5m" />
      </Deferred>
      <Deferred minHeight="300px" background="bg-sand" data-id="element-28" data-mp="1m565ibms7wp3">
        <Footer data-id="element-29" data-mp="1m3l88e931znj" />
      </Deferred>
      <Suspense fallback={null} data-id="element-30" data-mp="6ofdunwudtex">
        <StickyBuyBar data-id="element-31" data-mp="6o5w1nlyaskb" />
      </Suspense>
    </main>;
}